export const AIRSPACE_DISCLAIMER = 'airspace-disclaimer-acknowledgement';
